export const IMAGE_TYPE={
    LOGO: 'logo',
    PROFILE: 'profile'
};
